const CACHE_PREFIX = 'ec:capital-summary:v1:';
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export const effectiveCapitalCacheKey = (userId) => `${CACHE_PREFIX}${userId ?? 'anon'}`;

export function readEffectiveCapitalCache(userId) {
  try {
    const raw = window.sessionStorage.getItem(effectiveCapitalCacheKey(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.savedAt || !parsed.summary || typeof parsed.summary !== 'object') return null;
    const savedAt = Date.parse(parsed.savedAt);
    if (!Number.isFinite(savedAt) || Date.now() - savedAt > MAX_AGE_MS) return null;
    return parsed.summary;
  } catch (error) {
    return null;
  }
}

export function writeEffectiveCapitalCache(userId, summary) {
  if (!summary || typeof summary !== 'object') return;
  try {
    window.sessionStorage.setItem(
      effectiveCapitalCacheKey(userId),
      JSON.stringify({ savedAt: new Date().toISOString(), summary }),
    );
  } catch (error) {
    // Cache persistence is best effort.
  }
}
